"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CachedItem = void 0;
var CachedItem = /** @class */ (function () {
    function CachedItem() {
        this.valid = false;
    }
    CachedItem.prototype.set = function (toCache) {
        this.cached = toCache;
        this.valid = true;
    };
    CachedItem.prototype.isValid = function () {
        return this.valid;
    };
    CachedItem.prototype.get = function () {
        return this.isValid() ? this.cached : undefined;
    };
    CachedItem.prototype.invalidate = function () {
        this.valid = false;
    };
    return CachedItem;
}());
exports.CachedItem = CachedItem;
//# sourceMappingURL=cached-item.js.map